/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
// eslint-disable-next-line sonarjs/class-name
export class httpRequestInterceptor implements HttpInterceptor {
	constructor(@Inject(AuthService) private authService: AuthService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		req = req.clone({
			headers: req.headers.set('Accept', 'application/json')
		});
		if (this.authService.isAuthenticated()) {
			const token = this.authService.getToken();

			req = req.clone({
				headers: req.headers.set('Authorization', `Bearer ${token}`)
			});
		}

		return next.handle(req);
	}
}
